import React, { useEffect, useState } from 'react'
// ** Dropdowns Imports
import UserDropdown from "./UserDropdown"
//import NotificationDropdown from "./NotificationDropdown"
import { Button } from "reactstrap"
import CreateWorkorder from './CreateWorkorder'
import NavbarCreate from './NavbarCreate'
import { useSelector } from "react-redux"
import { isUserLoggedIn } from "../../../../utility/Utils"
import { useNavigate, useParams } from "react-router-dom"

const NavbarUser = () => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn())?.isEmployee
  const { woId } = useParams()
  const navigate = useNavigate()

  const [centeredModal, setCenteredModal] = useState(false)
  const [categoryId, setCategoryId] = useState(null)
  const [typeId, setTypeId] = useState(null)
  const [valid, setValid] = useState(false)

  const clsModel = (centeredModal) => {
    setCenteredModal(centeredModal)
  }

  useEffect(() => {
    if (stores.woCates && stores.woCates.length > 0) {
      const woCates = stores.woCates.length > 0 ? stores.woCates : []
      if (woCates.find(find => find.value === 4)) {
        setCategoryId(woCates.find(find => find.value === 4))
        const woTypes = woCates.find(find => find.value === 4).woTypes
        if (woTypes.find(find => find.value === 11)) {
          setTypeId(woTypes.find(find => find.value === 11))
        }
      }
    }
  }, [stores.woCates, stores.woCates.length])

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <div className='d-none'>
        <Button.Ripple color='primary' className="create_primary_btn_dashboard" onClick={() => {
          if (isEmployee) {
            setValid(true)
            setCenteredModal(!centeredModal)
          } else {
            setValid(false)
            if (woId) {
              navigate('/pageRefresh')
              setTimeout(() => {
                navigate(`/${categoryId.code}/${typeId.code}/save`)
              }, 100)
            } else {
              navigate(`/${categoryId.code}/${typeId.code}/save`)
            }
          }
        }}>
          <span className='align-middles ms-25'>Create New Subscription</span>
        </Button.Ripple>
        <Button.Ripple color='primary' className="create_primary_btn_dashboard" onClick={() => {
          setCenteredModal(!centeredModal)
          setValid(false)
        }}>
          <span className='align-middles ms-25'>Create New Workorder</span>
        </Button.Ripple>
        {centeredModal &&
          <CreateWorkorder centerModal={centeredModal} closeModel={clsModel} categoryId={categoryId} typeId={typeId} valid={valid} />
        }
      </div>
      <NavbarCreate />
      {/* <NotificationDropdown /> */}
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser